<template>
  <v-dialog v-model="modelLembrete" width="500px" v-on:update:modelValue="fechar">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card v-if="lembrete != null">
      <v-card-title class="text-color-1">
        {{ lembrete.title }}
      </v-card-title>
      <v-card-subtitle class="text-color-0">{{ $formatDate(lembrete.date_hour) }} às {{ $formatTime(lembrete.date_hour).replace(":", "h") }}</v-card-subtitle>
      <v-card-text class="pa-4">
        <v-img v-if="lembrete.image != '' && lembrete.image != null && lembrete.image != undefined && lembrete.image != 'no-image'" :src="lembrete.image" alt="Produto"></v-img>
        <div class="text-color-0 pt-4" v-html="lembrete.description"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DialogLembrete',
  data(){
    return {
      modelLembrete: false
    }
  },
  props: {
    lembrete: {
      type: Object,
      default: null
    },
    model: {
      type: Boolean,
      default: false,
      required: true
    },
    fechar: {
      type: Function,
      default: null,
      required: true
    }
  },
  watch: {
    model() {
      this.modelLembrete = this.model
    }
  }
}
</script>